import React from 'react';
import Modal from '~/components/Modal';
import { css } from 'emotion';
import sv from '@drawbotics/style-vars';


const styles = {
  infoModal: css`
    background: ${sv.white};
    padding: ${sv.basePaddingSmall};
    border-radius: ${sv.baseBorderRadius};
    margin: ${sv.baseMarginSmall};
  `,
  icon: css`
    text-align: center;
    font-size: 2.7em;
    color: ${sv.brandBlue};
  `,
  content: css`
    padding: ${sv.basePaddingSmall};
  `,
};


const InfoModal = ({ visible, isVisible, children }) => {
  return (
    <Modal isVisible={visible || isVisible}>
      <div className={styles.infoModal}>
        <div className={styles.icon}>
          <i className="ion-information-circled" />
        </div>
        <div className={styles.content}>
          {children}
        </div>
      </div>
    </Modal>
  );
}


export default InfoModal;
